import { WxMpPermissionMenuInfo } from '@/api/login/permissionType'
import { http } from '@/utils/http'

/**
 *查询微信小程序权限菜单
 */
export function requestGetRolesPermissions() {
  return http.get<WxMpPermissionMenuInfo[]>(
    `/clubs/mini-menus`,
  )
}
